(() => {
  const placeBreadcrumbs = () => {
    const breadcrumbs = document.querySelector('[data-ab-breadcrumbs]');
    if (!breadcrumbs) return;

    const productTarget = document.querySelector('product-info product-component > .page-width');
    const collectionTarget = document.querySelector('.ab-collection-hero .ab-page-width');
    const target = productTarget || collectionTarget;

    if (target && breadcrumbs.parentElement !== target) {
      target.prepend(breadcrumbs);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBreadcrumbs, { once: true });
  } else {
    placeBreadcrumbs();
  }
})();
